import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from './icon.js';
import { cn } from './cn.js';
/** The decorative, animated indicator shared by expand/collapse controls.
 * The host keeps its accessible name, state, panel relationship and behavior.
 */
export function DisclosureChevron({ expanded, direction = 'down', className }) {
    return _jsx(Icon, { name: "expand", size: 20, className: cn('ui-disclosure-chevron', className), "data-slot": "disclosure-chevron", "data-expanded": expanded, "data-direction": direction });
}
//# sourceMappingURL=disclosure-chevron.js.map